import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { pathname } = useLocation();

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    const handleNavigation = (path) => {
        setIsMenuOpen(false);
        if (pathname === path) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    return (
        <header className="bg-white shadow-md sticky top-0 z-50">
            <div className="container mx-auto px-6 md:px-12 py-3 flex justify-between items-center">
                {/* Logo */}
                <Link to="/" onClick={() => handleNavigation('/')} className="flex items-center">
                    <img
                        src="/assets/Community Plus Care (1).svg"
                        alt="Community Plus Care Services"
                        className="h-24 w-auto"
                    />
                </Link>

                {/* Desktop Navigation */}
                <nav className="hidden md:flex space-x-8">
                    <Link to="/" onClick={() => handleNavigation('/')} className="text-gray-700 hover:text-cp-teal font-medium transition-colors">HOME</Link>
                    <Link to="/about" onClick={() => handleNavigation('/about')} className="text-gray-700 hover:text-cp-teal font-medium transition-colors">ABOUT</Link>
                    <Link to="/services" onClick={() => handleNavigation('/services')} className="text-gray-700 hover:text-cp-teal font-medium transition-colors">SERVICES</Link>
                    <Link to="/careers" onClick={() => handleNavigation('/careers')} className="text-gray-700 hover:text-cp-teal font-medium transition-colors">CAREERS</Link>
                    <Link to="/register" onClick={() => handleNavigation('/register')} className="text-gray-700 hover:text-cp-teal font-medium transition-colors">REGISTER</Link>
                    <Link to="/contact" onClick={() => handleNavigation('/contact')} className="text-gray-700 hover:text-cp-teal font-medium transition-colors">CONTACT US</Link>
                </nav>

                {/* Mobile Menu Button */}
                <button
                    className="md:hidden text-gray-700 focus:outline-none"
                    onClick={toggleMenu}
                >
                    {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
                </button>
            </div>

            {/* Mobile Navigation */}
            {isMenuOpen && (
                <div className="md:hidden bg-white border-t border-gray-100">
                    <div className="flex flex-col p-4 space-y-4">
                        <Link to="/" className="text-gray-700 hover:text-cp-teal font-medium" onClick={() => handleNavigation('/')}>HOME</Link>
                        <Link to="/about" className="text-gray-700 hover:text-cp-teal font-medium" onClick={() => handleNavigation('/about')}>ABOUT</Link>
                        <Link to="/services" className="text-gray-700 hover:text-cp-teal font-medium" onClick={() => handleNavigation('/services')}>SERVICES</Link>
                        <Link to="/careers" className="text-gray-700 hover:text-cp-teal font-medium" onClick={() => handleNavigation('/careers')}>CAREERS</Link>
                        <Link to="/register" className="text-gray-700 hover:text-cp-teal font-medium" onClick={() => handleNavigation('/register')}>REGISTER</Link>
                        <Link to="/contact" className="text-gray-700 hover:text-cp-teal font-medium" onClick={() => handleNavigation('/contact')}>CONTACT US</Link>
                    </div>
                </div>
            )}
        </header>
    );
};

export default Header;
